const metaTags = [
  {
    name: 'description',
    content: 'This section highlights the performance of each listing in your shop, areas for improvement, and other reports to help you analyze your shop listings',
  },
  {
    name: 'og:title',
    content: 'eRank \u2014 Listings',
  },
  {
    name: 'og:description',
    content: 'This section highlights the performance of each listing in your shop, areas for improvement, and other reports to help you analyze your shop listings',
  },
  {
    name: 'og:site_name',
    content: 'eRank',
  },
  {
    name: 'og:type',
    content: 'website',
  },
  {
    name: 'twitter:title',
    content: 'eRank \u2014 Listings',
  },
  {
    name: 'twitter:description',
    content: 'This section highlights the performance of each listing in your shop, areas for improvement, and other reports to help you analyze your shop listings',
  },
  {
    name: 'twitter:image',
    content: '/img/erank-meta.png',
  },
  {
    name: 'twitter:card',
    content: 'summary',
  },
  {
    name: 'p:domain_verify',
    content: '4a452b9edfa7318bd9a45fe0d20a25c0',
  },
  {
    name: 'google-site-verification',
    content: '-2cfMO7MeRJeifFFxsIOq3Ifssa2ai61ngBq40DYYkM',
  },
  {
    name: 'msvalidate.01',
    content: '65CFA6CFB407B1A92CCA3F3FB7B1D174',
  },
  {
    name: 'msapplication-TileColor',
    content: '#da532c',
  },
  {
    name: 'msapplication-config',
    content: '/favicons/browserconfig.xml',
  },
  {
    name: 'theme-color',
    content: '#ffffff',
  },
  {
    name: 'apple-mobile-web-app-capable',
    content: 'yes',
  },
  {
    name: 'mobile-web-app-capable',
    content: 'yes',
  },
];

export default [
  {
    path: '/listings',
    name: 'listings',
    redirect: '/listings/active',
    component: () => import('@/modules/listings/pages/Entry.vue'),
    meta: {
      title: 'eRank \u2014 Listings',
      noScroll: true,
      requiresAuth: true,
      metaTags: [
        ...metaTags,
        {
          page_slug: 'listings',
        },
      ],
    },
    children: [
      {
        name: 'active',
        path: 'active',
        component: () => import('@/modules/listings/pages/Active.vue'),
      },
      {
        name: 'draft',
        path: 'draft',
        component: () => import('@/modules/listings/pages/Draft.vue'),
      },
      {
        path: 'expired',
        name: 'expired',
        component: () => import('@/modules/listings/pages/Expired.vue'),
      },
      {
        path: 'sold-out',
        name: 'sold-out',
        component: () => import('@/modules/listings/pages/SoldOut.vue'),
      },
      {
        path: 'thumbnail-preview',
        name: 'thumbnail-preview',
        component: () => import('@/modules/listings/pages/ThumbnailPreview.vue'),
      },
    ],
  },
  {
    path: '/expired',
    name: 'expired-listings',
    component: () => import('@/modules/listings/pages/CTAExpired.vue'),
    meta: {
      title: 'eRank \u2014 Listings',
      noScroll: true,
      requiresAuth: true,
      metaTags: [
        ...metaTags,
        {
          page_slug: 'expired-listings',
        },
      ],
    },
  },
  {
    path: '/draft',
    name: 'draft-listings',
    component: () => import('@/modules/listings/pages/CTADraft.vue'),
    meta: {
      title: 'eRank \u2014 Listings',
      noScroll: true,
      requiresAuth: true,
      metaTags: [
        ...metaTags,
        {
          page_slug: 'draft-listings',
        },
      ],
    },
  },
];
